import React from "react";
import CodeOrg from "assets/images/code_org.svg";
import BBC from "assets/images/bbc_logo.svg";
import Ashrena from "assets/images/1.png";
import { Link } from "gatsby";



export default function ReviewCardsDesign2() {
  return (
    <div>
      <div className="mainContainer w-full flex flex-col lg:flex-row lg:flex-grow-0 mx-auto justify-center text-white my-4 lg:gap-x-6 ">
        <Link to="https://www.trustpilot.com/users/60db02325f811c001128d575" className="cardOne  bg-boxColor h-[450px] rounded-2xl p-6 lg:w-22REM w-full  relative mb-6 lg:mb-0">
          <p className=" font-opensans font-semibold text-base">
            "Speedy return & <br /> reasonably priced"
          </p>
          <p className="mt-6 font-opensans  font-light text-light text-sm tracking-wider leading-[22px]">
            A translation company well equipped with knowledge of hundreds of
            different languages - speedy return & reasonably priced.
          </p>
          <div className="name absolute bottom-0 mb-4 pb-6">
            <img src={BBC} alt="" className="mb-2" />
            <div className="font-secondary font-semibold text-lg">Katherine Lindsay</div>
          </div>
        </Link>
        <Link to="https://www.trustpilot.com/users/60945782a8fc63001b6f847b" className="cardTwo bg-boxColor rounded-2xl lg:w-22REM w-full p-6 relative mb-6 lg:mb-0">
          <p className=" font-opensans font-semibold text-base">
            "Tomedes has been nothing but kind, knowledgeable and efficient!"
          </p>
          <p className="mt-6 font-opensans  font-light text-sm mb-28 tracking-wider leading-[22px]">
            Tomedes has been nothing but kind, knowledgeable and
            efficient!...Everything was seamless! I trusted Tomedes so much
            they’re now working...with an even bigger project: interpreting a
            multi-language Zoom meeting!
          </p>
          <div className="name mt-12 absolute bottom-0 mb-4 pb-6">
            <img src={Ashrena} alt="" className="mb-2" />
            <div className="font-secondary font-semibold text-lg">Ashrena Ali</div>
          </div>
        </Link>
        <Link className="cardThree bg-boxColor rounded-2xl p-6 w-full relative lg:w-22REM">
          <p className=" font-opensans font-semibold text-base">
            "Efficient and very good customer service."
          </p>
          <p className="mt-6 font-opensans  font-light text-sm mb-28 tracking-wider leading-[22px]">
            The Tomedes team was very responsive and quick to help us address
            any issues related to timeline and quality of translation...I would
            recommend the Tomedes team to any computer science curriculum
            providers.
          </p>
          <div className="name absolute bottom-0 mb-4 pb-6">
            <img src={CodeOrg} alt="" className="mb-2" />
            <div className="font-secondary font-semibold text-lg">Jorge Castro</div>
          </div>
        </Link>
      </div>
    </div>
  );
}
